// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Dialogs UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezDialog-container {
  display: none;
}

.ezDialog-layout-container {
  display: grid;
  grid-template-columns: min-content auto;
  grid-template-rows: auto;
  justify-content: stretch;
  align-content: start;
  grid-column-gap: 10px;
}

.ezDialog-message-container {
  overflow: auto;
}

/* -------------------------------------------------------------------
| JQuery UI Dialog Overrides (default)                               |
------------------------------------------------------------------- */
.ezDialog-content-border-silver {
  margin-top: 10px;
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

.ezDialog-no-close-button .ui-dialog-titlebar-close {
  display: none;
}

.ezDialog-without-icon {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto;
  justify-content: start;
  align-content: start;
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezDialog-with-icon {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: min-content auto;
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezDialog-icon-container {
  display: grid;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
  grid-template-rows: auto;
  grid-template-columns: auto;
  align-content: start;
  justify-content: justify-content;
  background-color: transparent;
}

img.ezDialog-icon {
  padding: 0;
  margin: 0;
  width: 32px;
  height: 32px;
  border-style: none;
}

.ezDialog-content-container {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-radius: 3px;
}

.ezDialog-content-silver-container_4px {
  padding: 4px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezDialog-content-silver-container_8px {
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ez-dialog-shadow {
  /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.4); */
  box-shadow: 0 0 4px 2px rgb(0 0 0/40%);
}

/*
    @deprecated
    Migrate to: ezDialog-content-container
*/
.ezDialog-content {
  margin-top: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border-style: none;
}

/*
    @deprecated
    Migrate to classes starting with 'ezDialog-' or
    use ez-padding.css classes.
*/
.ui-corner-all {
  border-radius: 3px;
}

/*
    @deprecated
    Migrate to classes starting with 'ezDialog-' or
    use ez-layout-grid.css classes.
*/
.ez-dialog-no-scroll {
  overflow: hidden;
}

/* Older Dialog Styles */
/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
div.ezClockerDialog {
  display: none;
}

/*
    @deprecated
    Migrate to: ezDialog-icon
*/
img.ezClockerDialogImage {
  height: 32px;
  width: 32px;
  margin-top: 0;
  margin-right: 10px;
}

.ezDialog-icon-container {
  display: grid;
  /* Y-Axis */
  align-content: start;
  /* X-Axis */
  justify-content: start;
  padding-left: 10xp;
  padding-right: 10px;
}

.ezDialog-icon {
  margin: 10px;
  height: 32px;
  width: 32px;
}

/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
table.ezClockerDialogContent {
  width: 100%;
  border-style: none;
}

/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
td.ezClockerDialogImageCell {
  text-align: left;
  vertical-align: top;
  width: 34px;
  border-style: none;
}

/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
td.ezClockerDialogMessageCell {
  vertical-align: top;
  text-align: left;
  border-style: none;
}

/*
    @deprecated
    Migrate to: ezDialog-without-icon or ezDialog-with-icon
*/
div.genericDialog {
  padding: 8px;
}

/*
    @deprecated
    Migrate to classes starting with 'ezDialog-' or
    use ez-text.css classes.
*/
.ezDialogTextInputContainerHighlight {
  box-shadow: 0 0 15px 1px #ffcc66;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {

}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {

}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {

}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {

}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-dialogs.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,aAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uCAAA;EACA,wBAAA;EACA,wBAAA;EACA,oBAAA;EACA,qBAAA;AAAJ;;AAIA;EACI,cAAA;AADJ;;AAIA;;qEAAA;AAIA;EACI,gBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,aAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,wBAAA;EACA,uCAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;EACA,oBAAA;EACA,gCAAA;EACA,6BAAA;AAFJ;;AAKA;EACI,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,uCAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,gDAAA;EACA,sCAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,eAAA;EACA,uCAAA;EACA,4BAAA;EACA,kBAAA;AAFJ;;AAKA;;;;CAAA;AAKA;EACI,kBAAA;AAFJ;;AAKA;;;;CAAA;AAKA;EACI,gBAAA;AAFJ;;AAKA,wBAAA;AACA;;;CAAA;AAIA;EACI,aAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,YAAA;EACA,WAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,WAAA;EACA,kBAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,YAAA;AAFJ;;AAKA;;;;CAAA;AAKA;EACI,gCAAA;AAFJ;;AAKA;;qEAAA;AAGA;;;;CAAA;AAOA;;qEAAA;AAGA;;;;CAAA;AAMA;;qEAAA;AAGA;;;;CAAA;AAMA;;qEAAA;AAGA;;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Dialogs UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n.ezDialog-container {\r\n    display: none;\r\n}\r\n\r\n.ezDialog-layout-container {\r\n    display: grid;\r\n    grid-template-columns: min-content auto;\r\n    grid-template-rows: auto;\r\n    justify-content: stretch;\r\n    align-content: start;\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n\r\n.ezDialog-message-container {\r\n    overflow: auto;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| JQuery UI Dialog Overrides (default)                               |\r\n------------------------------------------------------------------- */\r\n\r\n.ezDialog-content-border-silver {\r\n    margin-top: 10px;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezDialog-no-close-button .ui-dialog-titlebar-close {\r\n    display: none;\r\n}\r\n\r\n.ezDialog-without-icon {\r\n    display: grid;\r\n    grid-template-rows: auto;\r\n    grid-template-columns: auto;\r\n    justify-content: start;\r\n    align-content: start;\r\n    background-color: var(--ezAlphaBackgroundWhite1);\r\n    background-size: var(--ezBackgroundImageSize);\r\n    background-image: var(--ezBackgroundImage);\r\n    color: var(--ezContentFontColor);\r\n    font-size: var(--ezContentFontSize);\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n}\r\n\r\n.ezDialog-with-icon {\r\n    display: grid;\r\n    grid-template-rows: auto;\r\n    grid-template-columns: min-content auto;\r\n    background-color: var(--ezAlphaBackgroundWhite1);\r\n    background-size: var(--ezBackgroundImageSize);\r\n    background-image: var(--ezBackgroundImage);\r\n    color: var(--ezContentFontColor);\r\n    font-size: var(--ezContentFontSize);\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n}\r\n\r\n.ezDialog-icon-container {\r\n    display: grid;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    grid-template-rows: auto;\r\n    grid-template-columns: auto;\r\n    align-content: start;\r\n    justify-content: justify-content;\r\n    background-color: transparent;\r\n}\r\n\r\nimg.ezDialog-icon {\r\n    padding: 0;\r\n    margin: 0;\r\n    width: 32px;\r\n    height: 32px;\r\n    border-style: none;\r\n}\r\n\r\n.ezDialog-content-container {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezDialog-content-silver-container_4px {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezBorderSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezDialog-content-silver-container_8px {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerSilver);\r\n    color: var(--ezClockerBlack);\r\n    border-color: var(--ezBorderSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ez-dialog-shadow {\r\n    /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.4); */\r\n    box-shadow: 0 0 4px 2px rgb(0 0 0 / 40%);\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to: ezDialog-content-container\r\n*/\r\n.ezDialog-content {\r\n    margin-top: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    border-style: none;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to classes starting with 'ezDialog-' or\r\n    use ez-padding.css classes.\r\n*/\r\n.ui-corner-all {\r\n    border-radius: 3px;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to classes starting with 'ezDialog-' or\r\n    use ez-layout-grid.css classes.\r\n*/\r\n.ez-dialog-no-scroll {\r\n    overflow: hidden;\r\n}\r\n\r\n/* Older Dialog Styles */\r\n/*\r\n    @deprecated\r\n    Migrate to classes starting with: ezDialog-\r\n*/\r\ndiv.ezClockerDialog {\r\n    display: none;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to: ezDialog-icon\r\n*/\r\nimg.ezClockerDialogImage {\r\n    height: 32px;\r\n    width: 32px;\r\n    margin-top: 0;\r\n    margin-right: 10px;\r\n}\r\n\r\n.ezDialog-icon-container {\r\n    display: grid;\r\n    /* Y-Axis */\r\n    align-content: start;\r\n    /* X-Axis */\r\n    justify-content: start;\r\n    padding-left: 10xp;\r\n    padding-right: 10px;\r\n}\r\n\r\n.ezDialog-icon {\r\n    margin: 10px;\r\n    height: 32px;\r\n    width: 32px;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to classes starting with: ezDialog-\r\n*/\r\ntable.ezClockerDialogContent {\r\n    width: 100%;\r\n    border-style: none;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to classes starting with: ezDialog-\r\n*/\r\ntd.ezClockerDialogImageCell {\r\n    text-align: left;\r\n    vertical-align: top;\r\n    width: 34px;\r\n    border-style: none;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to classes starting with: ezDialog-\r\n*/\r\ntd.ezClockerDialogMessageCell {\r\n    vertical-align: top;\r\n    text-align: left;\r\n    border-style: none;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to: ezDialog-without-icon or ezDialog-with-icon\r\n*/\r\ndiv.genericDialog {\r\n    padding: 8px;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to classes starting with 'ezDialog-' or\r\n    use ez-text.css classes.\r\n*/\r\n.ezDialogTextInputContainerHighlight {\r\n    box-shadow: 0 0 15px 1px #ffcc66;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n\r\n}\r\n*/\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 480px) {\r\n\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 319px) {\r\n\r\n}\r\n*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
